<div class="beatmaker-info-container">
  <div class="beatmaker-info">
    <div class="beatmaker-info__avatar-box" (click)="handleBeatmakerInfoClick()">
      <img
        src="{{ producer?.images.thumbnail }}"
        alt="{{producer.beatmakerName} avatar}"
        [routerLink]="['/bm/', producer?.beatmakerId]"
      />
    </div>

    <span
      class="beatmaker-info__name"
      (click)="handleBeatmakerInfoClick()"
      [routerLink]="['/bm/', producer?.beatmakerId]"
    >
      {{ producer?.beatmakerName }}
    </span>

    @if (producer?.verified && showVerificationIcon) {
      <bmcore-verify-icon
        class="beatmaker-info__verification-icon"
        [variant]="'svg'"
        [height]="verificationIconSize"
        [width]="verificationIconSize"
      ></bmcore-verify-icon>
    }
  </div>

  @if (showFollowBtn) {
    <bmcore-follow-btn
      [beatmakerId]="producer?.beatmakerId"
      [beatmakerName]="producer?.beatmakerName"
      [variant]="'text'"
    ></bmcore-follow-btn>
  }
</div>
